module.exports = __webpack_public_path__ + "img/switzerland-breast-cancer-female.63e8aa5f.png";